import { Language } from "../languages/labels/language.labels";

export function taxStatusPeriodList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'open', display: lang.labels.open },
    { code: 'filed', display: lang.labels.filed },
    { code: 'closed', display: lang.labels.closed }
  ]
}

export function taxStatusPeriodValue(lang: Language, code: string): string {
  let contactType = taxStatusPeriodList(lang).find((item) => (item.code === code))
  return contactType ? contactType.display : lang.labels.undefined
}
